import React from "react";

/* =========================================================
   src/contact.jsx - shadcn-style form
   ========================================================= */

function Contact() {
  const [values, setValues] = React.useState({ name: "", email: "", company: "", message: "" });
  const [errors, setErrors] = React.useState({});
  const [submitting, setSubmitting] = React.useState(false);
  const [done, setDone] = React.useState(false);

  const update = (k) => (e) => {
    setValues((v) => ({ ...v, [k]: e.target.value }));
    if (errors[k]) setErrors((p) => ({ ...p, [k]: undefined }));
  };

  const validate = () => {
    const e = {};
    if (!values.name.trim()) e.name = "Please enter your name.";
    if (!values.email.trim()) e.email = "Please enter your email.";else
    if (!/^\S+@\S+\.\S+$/.test(values.email)) e.email = "That doesn't look like a valid email.";
    if (!values.message.trim()) e.message = "Tell us a little about your project.";
    return e;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length) return;
    setSubmitting(true);
    setTimeout(() => {
      setSubmitting(false);
      setDone(true);
      setValues({ name: "", email: "", company: "", message: "" });
    }, 700);
  };

  return (
    <section id="contact-section">
      <div className="wrap">
        <div className="contact-grid">
          <div className="contact-info">
            <div className="sec-tag">Get in touch</div>
            <h3>Interested? <em>Let's talk.</em></h3>
            <p>
              Tell us a little about what you're working on - we usually reply within one business day.
            </p>
            <div className="contact-meta">
              <ContactRow icon="Mail" label="Email">
                <a className="contact-meta-value" href="mailto:info@morsecode.cz">info@morsecode.cz</a>
              </ContactRow>
              <ContactRow icon="MapPin" label="Office">
                <div className="contact-meta-value">Spálená 480/1, 602 00 Brno-Trnitá</div>
              </ContactRow>
              <ContactRow icon="LifeBuoy" label="Support">
                <a className="contact-meta-value" href="https://morsecodesro.youtrack.cloud/" target="_blank" rel="noopener noreferrer">
                  Open the helpdesk <Icon name="ArrowUpRight" size={14} />
                </a>
              </ContactRow>
            </div>
          </div>

          <form className="form-card" onSubmit={onSubmit} noValidate>
            <div className="form-row">
              <div className="form-grid-2">
                <Field id="cf-name" label="Your name" error={errors.name}>
                  <Input
                  id="cf-name"
                  placeholder="Jane Doe"
                  autoComplete="name"
                  value={values.name}
                  onChange={update("name")}
                  aria-invalid={!!errors.name} />
                
                </Field>
                <Field id="cf-email" label="Email" error={errors.email}>
                  <Input
                  id="cf-email"
                  type="email"
                  placeholder="jane@company.com"
                  autoComplete="email"
                  value={values.email}
                  onChange={update("email")}
                  aria-invalid={!!errors.email} />
                
                </Field>
              </div>
              <Field id="cf-message" label="How can we help?" error={errors.message}>
                <Textarea
                id="cf-message"
                placeholder="A short description of what you're working on…"
                value={values.message}
                onChange={update("message")}
                aria-invalid={!!errors.message} />
              
              </Field>

              <div className="submit-row">
                <small>Replies within 1 business day.</small>
                <Button size="lg" disabled={submitting} type="submit">
                  {submitting ?
                <>
                      <Icon name="Loader" size={14} className="spin" />
                      Sending…
                    </> :

                <>
                      Send message
                      <Icon name="ArrowRight" size={14} className="btn-arrow" />
                    </>
                }
                </Button>
              </div>
            </div>
            {done && (
              <Alert>
                Thanks - we've received your message. We'll reply within one business day.
              </Alert>
            )}
          </form>
        </div>

        <FooterStrip />
      </div>
    </section>
  );
}

function FooterStrip() {
  return (
    <div className="contact-foot">
      <div className="contact-foot-grid">
        <div className="cf-col cf-brand">
          <h4>Morse &amp; Code <em>s.r.o.</em></h4>
          <p>Accelerate innovation and transformation with a fully integrated suite of capabilities.</p>
          <div className="socials">
            <a href="https://www.linkedin.com/company/103496080/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <Icon name="Linkedin" size={16} strokeWidth={1.8} />
            </a>
            <a href="https://www.linkedin.com/company/103496080/" target="_blank" rel="noopener noreferrer" aria-label="X / Twitter">
              <Icon name="Twitter" size={16} strokeWidth={1.8} />
            </a>
            <a href="mailto:info@morsecode.cz" aria-label="Email" style={{ borderWidth: "0px", borderStyle: "none" }}>
              <Icon name="Mail" size={16} strokeWidth={1.8} />
            </a>
          </div>
        </div>
        <div className="cf-col">
          <h5>Office</h5>
          <p>Spálená 480/1<br />602 00 Brno-Trnitá</p>
          <a href="mailto:info@morsecode.cz">info@morsecode.cz</a>
        </div>
        <div className="cf-col">
          <h5>Registry</h5>
          <p>IČ: 21426937 · DIČ: CZ21426937</p>
          <p>Krajský soud v Brně, oddíl C, vložka 138867</p>
          <p>ID datové schránky: 2tm7mws</p>
        </div>
      </div>
      <div className="contact-foot-bottom">
        <span>© Morse &amp; Code s.r.o. - All rights reserved.</span>
        <span>Designed by Morse Design.</span>
      </div>
    </div>);

}

function ContactRow({ icon, label, children }) {
  return (
    <div className="contact-meta-row" data-hover>
      <div className="contact-meta-icon">
        <Icon name={icon} size={18} strokeWidth={1.8} />
      </div>
      <div>
        <div className="contact-meta-label">{label}</div>
        {children}
      </div>
    </div>);

}

Object.assign(window, { Contact });
